<template>

  <div>
    <div class="bold-text" v-if="displayLabel">
      {{ label }}
    </div>
    <div class="mt-2">
      {{textBefore}} {{getValue(property)}} {{textAfter}}
    </div>
  </div>

</template>

<script>

export default {

  name: 'ShowValueField',

  props: {
    object: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    property: {
      type: String,
      default: null
    },
    displayLabel: {
      type: Boolean,
      default: true
    },
    textBefore: {
      type: String,
      default: ''
    },
    textAfter: {
      type: String,
      default: ''
    },
    needTranslation: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    getValue () {
      return property => this.object? ((this.object[property] || this.object[property] === false) ? (this.needTranslation? this.$t(this.object[property]) : this.object[property]) : '-'): '-'
    }
  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/showFields/ShowValueField.vue